export const APP_PROGRESS_BUTTON_ANIMATION = {
  DEFAULT_PROGRESS_DURATION_MS: 4000,
  MILLISECONDS_PER_SECOND: 1000,
  INITIAL_PROGRESS_WIDTH: '0%',
  FINAL_PROGRESS_WIDTH: '100%',
  EASE: 'linear',
} as const;
